import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import { getShoppingCartMetaApi, getTrackersApi, getScriptsApi, fetchMetaAddressFormatApi, getMenuFeaturesApi, getStripeTokenApi } from 'api/fesc/client'
import * as C from './constants'
import { getUrlObject } from '@jarvis.oddle/core/tools/routes'
import { STORE_KEY as META_STORE_KEY } from './constants'
import {STORE_KEY as USER_STORE_KEY } from '../user/constants';

export const fetchShoppingCartMetaAction = ({ name, req, res }) => asyncAction({
  api: getShoppingCartMetaApi,
  requestAction: C.GET_SHOPPING_CART_META_REQUEST,
  successAction: C.GET_SHOPPING_CART_META_SUCCESS,
  failureAction: C.GET_SHOPPING_CART_META_FAILURE
})(() => {
  const storeId = getUrlObject(req).query['store-id']
  const referrer = getUrlObject(req).query['referrer']
  return { name, storeId, referrer, req, res }
})

export const fetchTrackersAction = asyncAction({
  api: getTrackersApi,
  requestAction: C.GET_TRACKERS_REQUEST,
  successAction: C.GET_TRACKERS_SUCCESS,
  failureAction: C.GET_TRACKERS_FAILURE
})

export const fetchScriptsAction = asyncAction({
  api: getScriptsApi,
  requestAction: C.GET_SCRIPTS_REQUEST,
  successAction: C.GET_SCRIPTS_SUCCESS,
  failureAction: C.GET_SCRIPTS_FAILURE
})

export const setBotMetaAction = ({ isBot }) => ({ type: C.SET_BOT_META, payload: { isBot } })

export const fetchMetaAddressFormatAction = ({ req }) => asyncAction({
  api: fetchMetaAddressFormatApi,
  requestAction: C.GET_ADDRESS_FORMAT_REQUEST,
  successAction: C.GET_ADDRESS_FORMAT_SUCCESS,
  failureAction: C.GET_ADDRESS_FORMAT_FAILURE
})((getState) => {
  const metaState = getState()[META_STORE_KEY]
  const { data: { menuId } } = metaState.meta
  return { menuId, req }
})

export const fetchMenuFeaturesAction = ({ req, features }) => asyncAction({
  api: getMenuFeaturesApi,
  requestAction: C.GET_MENU_FEATURES_REQUEST,
  successAction: C.GET_MENU_FEATURES_SUCCESS,
  failureAction: C.GET_MENU_FEATURES_FAILURE
})((getState) => {
  const metaState = getState()[META_STORE_KEY]
  const { data: { menuId } } = metaState.meta
  return { req, menuId, features }
})

export const getStripeTokenAction = (params) => asyncAction({
  api: getStripeTokenApi,
  requestAction: C.GET_STRIPE_TOKEN_REQUEST,
  successAction: C.GET_STRIPE_TOKEN_SUCCESS,
  failureAction: C.GET_STRIPE_TOKEN_FAILURE
})((getState) => {
  const { req } = params || {}
  const metaState = getState()[META_STORE_KEY]
  const userState = getState()[USER_STORE_KEY]
  const { data: { menuId } } = metaState.meta
  const testAccount = userState.user.data.testAccount; 
  return { req, menuId, testAccount }
})
